import {
  GET_SCORES_LOADING,
  GET_SCORES_SUCCESS,
  GET_SCORES_ERROR,
  SUBMIT_SCORES_LOADING,
  SUBMIT_SCORES_SUCCESS,
  SUBMIT_SCORES_ERROR,
  GET_MINIMAL_PLAYERS_LOADING,
  GET_MINIMAL_PLAYERS_SUCCESS,
  GET_MINIMAL_PLAYERS_ERROR,
} from "../../../constant/actionTypes";
import ApiEndpoints from "../../../utils/ApiEndpoints";
import { apiGet, apiPost } from "../../../utils/apiRequests";

export const getScores = () => (dispatch) => {
  dispatch({ type: GET_SCORES_LOADING });
  apiGet(
    "api/admin/users/getscores",
    (response) => {
      // console.log("get scores response ==============> ", response);
      if (response.error === true) {
        dispatch({ type: GET_SCORES_ERROR, response: response.message });
      } else {
        dispatch({ type: GET_SCORES_SUCCESS, response: response });
      }
    },
    (error) => {
      // console.log("error ===>>>>", error);
      dispatch({ type: GET_SCORES_ERROR, response: error });
    }
  );
};

export const getMinimalPlayers = (role) => (dispatch) => {
  dispatch({ type: GET_MINIMAL_PLAYERS_LOADING });

  if (role === "player") {
    apiGet(
      ApiEndpoints.minimalPlayers.player,
      (response) => {
        if (response.error === true) {
          console.log('players error: ', response.players);
          dispatch({
            type: GET_MINIMAL_PLAYERS_ERROR,
            response: response.message,
          });
        } else {
          console.log('players success: ', response.players);
          dispatch({
            type: GET_MINIMAL_PLAYERS_SUCCESS,
            response: response.players,
          });
        }
      },
      (error) => {
        // console.log("error ===>>>>", error);
        dispatch({ type: GET_MINIMAL_PLAYERS_ERROR, response: error });
      }
    );
  } else {
    apiGet(
      ApiEndpoints.minimalPlayers.get,
      (response) => {
        if (response.error === true) {
          dispatch({
            type: GET_MINIMAL_PLAYERS_ERROR,
            response: response.message,
          });
        } else {
          dispatch({
            type: GET_MINIMAL_PLAYERS_SUCCESS,
            response: response.data,
          });
        }
      },
      (error) => {
        dispatch({ type: GET_MINIMAL_PLAYERS_ERROR, response: error });
      }
    );
  }
};

export const submitScores = (data) => (dispatch) => {
  dispatch({ type: SUBMIT_SCORES_LOADING });
  apiPost(
    "/api/admin/users/addscore",
    data,
    (response) => {
      // console.log("submit scores response ....", response);

      if (response.error === true) {
        dispatch({ type: SUBMIT_SCORES_ERROR, response: response.message });
      } else {
        dispatch({ type: SUBMIT_SCORES_SUCCESS, response: response });
      }
    },
    (error) => {
      // console.log("error ===>>>>", error);
      dispatch({ type: SUBMIT_SCORES_ERROR, response: error });
    }
  );
};
